interface DashboardData {
  aircrafts: DashboardAircraftData;
}

export interface DashboardAircraftData {
  manufacturers: DashboardCategory[];
  cards: Record<string, DashboardAircraftCard[]>;
}

export interface DashboardCategory {
  label: string;
  id: string;
}

export interface DashboardAircraftCard {
  make: string;
  model: string;
  info: DashboardAircraftCardInfo[];
  content: ContentType3D;
}

export interface ContentType3D {
  asset: string;
  scale?: number;
}

export interface DashboardAircraftCardInfo {
  key: string;
  value: string | number;
}

export default {
  aircrafts: {
    manufacturers: [
      { label: 'Gulfstream', id: 'gulfstream' },
      { label: 'Boeing', id: 'boeing' },
      { label: 'Airbus', id: 'airbus' },
      { label: 'Embraer', id: 'embraer' },
      { label: 'Cessna', id: 'cessna' },
      { label: 'Bombardier', id: 'bombardier' },
      { label: 'Sukhoi', id: 'sukhoi' },
    ],
    cards: {
      gulfstream: [
        {
          make: 'Gulfstream',
          model: 'G450',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2012' },
            { key: 'Current Price', value: '$12,000,000' },
            { key: 'Engine Type', value: 'Honeywell TFE731' },
            { key: 'Range', value: '6,000 km' },
          ],
        },
        {
          make: 'Gulfstream',
          model: 'G550',
          content: { asset: 'plane2.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2015' },
            { key: 'Current Price', value: '$20,000,000' },
            { key: 'Engine Type', value: 'General Electric CF34' },
            { key: 'Range', value: '6,750 km' },
          ],
        },
      ],
      boeing: [
        {
          make: 'Boeing',
          model: '787 Dreamliner',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2016' },
            { key: 'Current Price', value: '$248,000,000' },
            { key: 'Engine Type', value: 'Rolls-Royce Trent 1000' },
            { key: 'Range', value: '14,300 km' },
          ],
        },
        {
          make: 'Boeing',
          model: '737 MAX',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2018' },
            { key: 'Current Price', value: '$100,000,000' },
            { key: 'Engine Type', value: 'CFM International LEAP-1B' },
            { key: 'Range', value: '11,000 km' },
          ],
        },
      ],
      airbus: [
        {
          make: 'Airbus',
          model: 'A380',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2010' },
            { key: 'Current Price', value: '$446,000,000' },
            { key: 'Engine Type', value: 'Engine Alliance GP7200' },
            { key: 'Range', value: '15,200 km' },
          ],
        },
        {
          make: 'Airbus',
          model: 'A350',
          content: { asset: 'plane2.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2020' },
            { key: 'Current Price', value: '$317,000,000' },
            { key: 'Engine Type', value: 'Rolls-Royce Trent XWB' },
            { key: 'Range', value: '15,000 km' },
          ],
        },
      ],
      embraer: [
        {
          make: 'Embraer',
          model: 'E195-E2',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2019' },
            { key: 'Current Price', value: '$60,000,000' },
            { key: 'Engine Type', value: 'Pratt & Whitney PW1900E' },
            { key: 'Range', value: '4,815 km' },
          ],
        },
      ],
      cessna: [
        {
          make: 'Cessna',
          model: 'Citation X',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2004' },
            { key: 'Current Price', value: '$23,000,000' },
            { key: 'Engine Type', value: 'Pratt & Whitney JT15D-5C' },
            { key: 'Range', value: '5,700 km' },
          ],
        },
      ],
      bombardier: [
        {
          make: 'Bombardier',
          model: 'CRJ900',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2012' },
            { key: 'Current Price', value: '$45,000,000' },
            { key: 'Engine Type', value: 'GE CF34-8C1' },
            { key: 'Range', value: '2,660 km' },
          ],
        },
      ],
      sukhoi: [
        {
          make: 'Sukhoi',
          model: 'Superjet 100',
          content: { asset: 'plane.glb' },
          info: [
            { key: 'Year of Manufacture', value: '2018' },
            { key: 'Current Price', value: '$50,000,000' },
            { key: 'Engine Type', value: 'Soloviev D-30KU' },
            { key: 'Range', value: '4,500 km' },
          ],
        },
      ],
    },
  },
} as DashboardData;
